export default class AddressBook {
    constructor(id, defaultAddress, location, formatAddress, country, state, street, postal, type, locality, references, otherDescription) {
        (this.id = id),
            (this.defaultAddress = defaultAddress),
            (this.location = location),
            (this.formatAddress = formatAddress),
            (this.country = country),
            (this.locality = locality),
            (this.state = state),
            (this.street = street),
            (this.postal = postal),
            (this.references = references),
            (this.type = type),
            (this.otherDescription = otherDescription);
    }
}
export class Location {
    constructor(lat, lng) {
        this.lat = lat;
        this.lng = lng;
    }
    static empty() {
        return new Location(0, 0);
    }
}
export var TypeAddressBook;
(function (TypeAddressBook) {
    TypeAddressBook["HOME"] = "HOME";
    TypeAddressBook["OFFICE"] = "OFFICE";
    TypeAddressBook["PARENT"] = "PARENT";
    TypeAddressBook["OTHER"] = "OTHER";
})(TypeAddressBook || (TypeAddressBook = {}));
export function typeAddressBookFromString(text) {
    const upper = text.trim().toUpperCase();
    const enumValues = Object.values(TypeAddressBook);
    const e = enumValues.find(val => val === upper);
    return e ? e : TypeAddressBook.OTHER;
}
